(function ClientReservations($, Adzuki)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		Adzuki.onload('/Clients/reservations', function clientReservations()
		{
			var $modal                           = $('.modal'),
			    cancelled_reservations_container = $(".cancelled-reservations"),
			    reservations_container           = $(".reservations"),
			    client_id                        = $("#client_id").val(),
			    cancelled_reservations_url       = '/Clients/_getCancelledReservations/' + client_id,
			    reservations_url                 = '/Clients/_getReservations/' + client_id;

			if (cancelled_reservations_container.length === 1) {
				Adzuki.Ajax.get(cancelled_reservations_url).then(function success(response) {
					cancelled_reservations_container.html(response);
				});
			}

			if (reservations_container.length === 1) {
				Adzuki.Ajax.get(reservations_url).then(function success(response) {
					reservations_container.html(response);
				});
			}


			$('.reservation-peek').on('click', '.reservation-details', function showReservationDetails(e)
			{
				e.preventDefault();
				$modal.find('.modal-body').text('Loading reservation details...');
				$modal.find('.modal-title').text('Reservation Details');
				$modal.modal('show');

				Adzuki.Ajax.get('/Reservations/reservationDetailsModal/'+$(this).data('reservation-id'))
				.then(function showDetails(data) {
					$modal.find('.modal-body').html(data);
				});
			});
		});
	});
}(jQuery, window.Adzuki || {}));